import React from 'react';
import PropTypes from 'prop-types';
import * as style from './ArticleCallOutCard.module.scss';
import BlogIcon from '../../BlogIcon';

/**
 *  Call out card consisting from: icon, title, text placed in a column
 */
const ArticleCallOutCard = (props) => {
  const { icon, title, text } = props;
  return (
    <div className={style.card}>
      <div className={style.iconCircle}>
        <BlogIcon
          iconName={icon}
          className={style.icon}
          width={24}
          height={24}
        />
      </div>
      <div className={style.title}>{title}</div>
      <div className={style.text}>{text}</div>
    </div>
  );
};

ArticleCallOutCard.propTypes = {
  /** Icon name */
  icon: PropTypes.string.isRequired,
  /** Card title */
  title: PropTypes.string.isRequired,
  /** Card text */
  text: PropTypes.string.isRequired,
};

export default ArticleCallOutCard;
